import { render, staticRenderFns } from "./CalendarRequests.vue?vue&type=template&id=55f79918&"
import script from "./CalendarRequests.vue?vue&type=script&lang=ts&"
export * from "./CalendarRequests.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports